import { Map } from 'immutable';
import Constants from '../../constants';
import { viewReducerReplacer } from '../helpers/views';

export const DEFAULT_STATE = Map({});

const expertsByTopic = viewReducerReplacer(
	Constants.FETCH_EXPERTS_BY_TOPIC,
	'experts',
	DEFAULT_STATE,
);

export default expertsByTopic;
